var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./MyADGViolationPopup.jinja');
require('./MyADGViolationPopup.less');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        'click .MyADGViolationPopup-thanksClose': 'close', //function from BasePopup proto
        'click .MyADGViolationPopup-formSubmit': 'onSubmitClick',
        'input input': 'onInputChange',
        'input textarea': 'onInputChange'
    }, BasePopup.prototype.baseEvents),


    initialize: function (options) {
        this.options = options || {};

        this.inputValues = {};

        BasePopup.prototype.initialize.call(this, options);
    },


    onSubmitClick: function () {

        var data = this.getFormData();

        if (!data.valid) return;

        this.$('.MyADGViolationPopup-formSubmit').addClass('Button--loading');

        this._xhr = $.ajax({
            'url': Urls['member:api:workplace-violation']('json'),
            'data': JSON.stringify(data.data),
            'contentType': 'application/json; charset=utf-8',
            'dataType': 'json',
            'method': 'POST',
            'success': function (data) {
                this.$el.addClass('MyADGViolationPopup--submitted');
                if (app.settings.isPhone) {
                    $(window).scrollTop(0);
                }
                this.$('.MyADGViolationPopup-formSubmit').removeClass('Button--loading');
            }.bind(this),
            'error': function () {
                alert('Something went wrong, try again later.');
                this.$('.MyADGViolationPopup-formSubmit').removeClass('Button--loading');
            }.bind(this),
            'context': this
        });
    },


    onInputChange: function (e) {
        var data = this.getFormData();
        this.$('.MyADGViolationPopup-form').toggleClass('MyADGViolationPopup-form--filled', !!data.valid);
    },


    getFormData: function () {
        var productionName = this.$('input[name="production-name"]').val();
        var productionPhone = this.$('input[name="production-phone"]').val();
        var location = this.$('input[name="location"]').val();
        var typeOfProduction = this.$('input[name="type-of-production"]').val();
        var explanation = this.$('textarea[name="explanation"]').val();

        return {
            valid: productionName && productionPhone && location && typeOfProduction && explanation,
            data: {
                productionName: productionName,
                productionPhone: productionPhone,
                location: location,
                typeOfProduction: typeOfProduction,
                explanation: explanation
            }
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MyADGViolationPopup/MyADGViolationPopup.js
// module id = 283
// module chunks = 0